import { Box, Typography, Divider, Paper } from "@mui/material";
import React from "react";

const ThinkingDetailContent = () => {
  return (
    <Box
      sx={{
        padding: { xs: "0rem 1.2rem 1.2rem 1.2rem", sm: "0 4rem 4rem" },
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontFamily: "Montserrat",
          fontSize: { xs: "1.4rem", sm: "1.6rem" },
          fontWeight: "500",
          marginTop: "1.2rem",
        }}
      >
        <span style={{ color: "rgba(255, 102, 0, 1)" }}>AI and The CEO </span>
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          fontWeight: "500",
          fontSize: { xs: "1.4rem", sm: "1.6rem" },
          marginTop: "1rem",
        }}
      >
        Introduction
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        The relevance of the title is high because AI appears to be the ultimate
        enabler of the corporate world, and the CEO is the ultimate
        decision-maker of that world.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        AI is the magic wand or the magic wizard (if humanized)* that can
        achieve 'anything' and be the CEO's best friend. AI can also be lethal
        and break the organization if not judiciously used. It's the classical
        silver bullet, which it indeed is unless misdirected to create damage.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        Let's unpack AI or Artificial Intelligence. It is a serious and
        pervasive area because of the word 'Intelligence.' Intelligence is
        fundamental to human existence. It is argued that Intelligence is the
        biggest differentiator between Humans and non-humans. So, whatever is
        associated with Intelligence is also associated with the human core. AI,
        by that token, multiplies the human core and, in essence, could have an
        almost-human effect.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        On the CEO's charter, if we assume the 'people' in and around his
        organization are his most important asset, then we would have to put AI
        as the 2nd most important topic for his attention. And argue that one
        day, AI might take the No. 1 spot. We all are aware that Artificial
        Intelligence has crossed Human Intelligence in many areas.
      </Typography>

      <Paper
        elevation={1}
        sx={{ padding: "1rem", marginTop: "2rem", bgcolor: "#f5f5f5" }}
      >
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontStyle: "italic",
            color: "rgba(51, 51, 51, 0.9)",
          }}
        >
          "Experts are calling AI the biggest event in human history."
        </Typography>
      </Paper>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        For the CEO, the use of AI is not a choice anymore. Not using AI creates
        a disadvantage that the CEO will find hard to counter versus the
        competition. At a minimum, AI use will evolve to become hygiene and, in
        its best use, a big differentiator.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        But he needs to ask a few fundamental questions when he is planning the
        deployment of AI:
      </Typography>

      <Box sx={{ marginLeft: "1rem", marginTop: "1rem" }}>
        <Typography
          component="div"
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
            "& > p": {
              marginTop: "0.5rem",
            },
          }}
        >
          <p>• What is the quality of the AI deployment</p>
          <p>• Where can AI produce the biggest benefits</p>
          <p>• What are the short- and long-term effects of his AI friend</p>
        </Typography>
      </Box>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        The answers to these questions need the same level of intellectual
        clarity that any of his most important business strategies have. This is
        important to call out because in the fast-evolving world of big tech,
        technicalities and jargon can create an opaque wall; leaders are often
        led to make decisions without having clarity about what they are signing
        up for.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        This is further underscored by the advancement of generative AI since
        the launch of ChatGPT, which has opened up exponentially new
        opportunities and equally big risks.
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          fontWeight: "500",
          fontSize: { xs: "1.4rem", sm: "1.6rem" },
          marginTop: "2rem",
        }}
      >
        What is the quality of the AI deployment
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        This is very important from a CEO standpoint because of 3 reasons:
      </Typography>

      <Box sx={{ marginLeft: "1rem", marginTop: "1rem" }}>
        <Typography
          component="div"
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
            "& > p": {
              marginTop: "1rem",
            },
          }}
        >
          <p>
            <strong>1.</strong> Essentially, AI is an empirical tool, not a
            theoretical model that is 'proven.' It deserves the cliched comment
            — 'it is as good as the training dataset is.' We often overlook this
            most fundamental question, the ill effects of which could be
            far-reaching, especially in markets like Bangladesh, because the
            'training data' for most AI models are likely to be heavily weighted
            by Western world data. The application of that to markets in the
            East could be good or perilous, depending on the use case. The
            creation of a relevant training dataset is not inexpensive.
          </p>
          <p>
            <strong>2.</strong> AI is a predictive tool; the newness of the
            technology (and the fact that it has been built in an open-source
            collaborative manner) has not allowed it to complete a validation
            cycle to understand the accuracy of the predictions. This is
            especially important for local applications in Corporations because
            of the highly contextual nature of those applications.
          </p>
        </Typography>
      </Box>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          fontWeight: "500",
          fontSize: { xs: "1.4rem", sm: "1.6rem" },
          marginTop: "2rem",
        }}
      >
        Where can AI produce the biggest benefits
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        Broadly, AI usefulness in the CEO's organization can be classified as:
      </Typography>

      <Box sx={{ marginLeft: "1rem", marginTop: "0.5rem" }}>
        <Typography
          component="div"
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
          }}
        >
          <p>[i] Efficiency outcomes</p>
          <p>[ii] Effectiveness outcomes</p>
          <p>[iii] Creativity outcomes</p>
        </Typography>
      </Box>

      <Box sx={{ marginTop: "1rem" }}>
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontWeight: "500",
            color: "rgba(51, 51, 51, 1)",
            marginTop: "1rem",
          }}
        >
          Efficiency outcomes
        </Typography>
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
          }}
        >
          are usually around process and workflow. Repetitive processes are done
          faster and cheaper with AI. Validation is easier, and training sets
          are easier to create. So, it's 'safer' to deploy AI here. This is a
          prime area and perhaps the first place for the CEO to onboard AI into
          his organization.
        </Typography>

        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontWeight: "500",
            color: "rgba(51, 51, 51, 1)",
            marginTop: "1rem",
          }}
        >
          Effectiveness
        </Typography>
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
          }}
        >
          relates to superior outcomes of the organization's output (sales,
          product quality, service quality, etc.). The impact of AI is likely to
          be highest here as it would move the core business metrics, hence an
          ideal area to deploy AI. But it's a high return-high risk spot, hence,
          needs to be handled carefully. Contextualization is very important;
          hence, it's not easy to find a solution at a reasonable cost and speed
          with a high guarantee of success.
        </Typography>

        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontWeight: "500",
            color: "rgba(51, 51, 51, 1)",
            marginTop: "1rem",
          }}
        >
          Creativity outcomes
        </Typography>
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
          }}
        >
          (e.g., creating product concepts, designs, and ads) are a newer area
          and generative AI plays at the center of this. This has very large
          cycle time gains and creates a 'good enough' product (hence mitigates
          the risk of a poor-quality output). However, there are several risks,
          as mentioned earlier, plus the key question of machine vs. human — who
          does what best if we intend to have truly outstanding and
          differentiated output?
        </Typography>
      </Box>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          fontWeight: "500",
          fontSize: { xs: "1.4rem", sm: "1.6rem" },
          marginTop: "2rem",
        }}
      >
        What are the short- and long-term effects of his AI friend
      </Typography>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        This is largely led by <strong>'HOW'</strong> we deploy AI in the
        organization —
      </Typography>

      <Box sx={{ marginLeft: "1rem", marginTop: "1rem" }}>
        <Typography
          component="div"
          sx={{
            fontFamily: "Plus Jakarta Sans",
            color: "rgba(51, 51, 51, 1)",
            "& > p": {
              marginTop: "0.5rem",
            },
          }}
        >
          <p>
            • Does the CEO have the right personnel or expertise in his
            organization to deploy AI well?
          </p>
          <p>
            • Has he prepared the organization to accept a tool that is likely
            to change the gut of the organization?
          </p>
          <p>
            • Does the organization have a culture of agility, adaptability,
            fast learning, and tolerance for failure?
          </p>
        </Typography>
      </Box>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
        }}
      >
        A final word: Today, AI's taking over CEO's jobs is becoming AI CEOs
        (Dictador, NetDragon, Alsthetic are examples). However, the CEO and the
        organization need to understand that AI is not a threat to human work or
        opportunity. If so, we would have faced equally big challenges when the
        motor car, the computer, or the internet happened. They created a
        tectonic shift in our lives and new opportunities but did not kill jobs.
      </Typography>

      <Paper
        elevation={1}
        sx={{ padding: "1rem", marginTop: "2rem", bgcolor: "#f5f5f5" }}
      >
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontStyle: "italic",
            color: "rgba(51, 51, 51, 0.9)",
          }}
        >
          "Alphabet and Google CEO says AI is more profound than Fire or
          Electricity."
        </Typography>
      </Paper>

      <Typography
        sx={{
          fontFamily: "Plus Jakarta Sans",
          marginTop: "1rem",
          color: "rgba(51, 51, 51, 1)",
          fontStyle: "italic",
        }}
      >
        Fire and electricity transformed us. They can and have had negative
        effects as well if not well handled. Today's CEO needs to embrace AI
        fully - but with care.
      </Typography>

      <Paper
        elevation={1}
        sx={{ padding: "1rem", marginTop: "2rem", bgcolor: "#f5f5f5" }}
      >
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontSize: "0.9rem",
            fontStyle: "italic",
            color: "rgba(51, 51, 51, 0.9)",
          }}
        >
          *The Editors of Encyclopædia Britannica define Human intelligence as
          the mental quality that consists of the abilities to learn from
          experience, adapt to new situations, understand and handle abstract
          concepts, and use knowledge to manipulate one's environment.
        </Typography>
      </Paper>

      <Divider sx={{ marginTop: "2rem" }} />
    </Box>
  );
};

export default ThinkingDetailContent;
